import Vue from 'vue'
import App from './register.vue'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#register',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/pages/register/register.js